import { useState } from 'react';
import SaveItemsStep from "./SaveItemsStep";
import UploadStep from "./UploadStep";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** Implements a generic import flow from a CSV file. Can be used to import a list of entities into the system. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function ImportWizard(props) {
  const {
    entityName,
    getItemTypeCounts,
    saveEntityName,
    importBtnText,
    csvTemplateUrl,
    testId,
    currentSaveData,
    parseAndValidateCsv,
    saveItem,
    onEvent,
    onStartSave
  } = props;
  const [step, setStep] = useState('uploadCsv');
  const [items, setItems] = useState([]);
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": testId,
    children: [step === 'uploadCsv' && /*#__PURE__*/_jsx(UploadStep, {
      entityName: entityName,
      getItemTypeCounts: getItemTypeCounts,
      importBtnText: importBtnText,
      csvTemplateUrl: csvTemplateUrl,
      testId: testId,
      parseAndValidateCsv: parseAndValidateCsv,
      onEvent: onEvent,
      onStartImportItems: items => {
        onEvent && onEvent('startImportItems');
        setItems(items);
        setStep('saveItems');
      },
      onUploadCsv: (items, errors, badCsv) => {
        onEvent && onEvent('csvUploaded', {
          items,
          errors,
          badCsv
        });
      }
    }), step === 'saveItems' && /*#__PURE__*/_jsx(SaveItemsStep, {
      items: items,
      saveEntityName: saveEntityName,
      currentSaveData: currentSaveData,
      testId: testId,
      saveItem: saveItem,
      onEvent: onEvent,
      onReset: () => setStep('uploadCsv'),
      onStartSave: onStartSave
    })]
  });
}